import { withConfigure } from "hyam-core/utils/withConfigure";
import {
  styles as moduleStyles,
  S01ImageSlidesDesktopMobileDefaultStyles,
} from "./styles";
import { ImageSlidesSliceDesktopMobile } from "root/prismicio-types";
import { HyamPrismicImage } from "hyam-prismic/components/elements";

export type S01ImageSlidesDesktopMobileDefaultProps = {
  slice: ImageSlidesSliceDesktopMobile;
  index: number;
  styles?: Partial<S01ImageSlidesDesktopMobileDefaultStyles>;
  stylesReplace?: Partial<S01ImageSlidesDesktopMobileDefaultStyles>;
};

const _S01ImageSlidesDesktopMobileDefault = (
  props: S01ImageSlidesDesktopMobileDefaultProps,
) => {
  const { slice } = props;
  const styles = props.styles as S01ImageSlidesDesktopMobileDefaultStyles;
  const items = slice?.items;

  return (
    <div className={styles.container}>
      <div className="h-full w-full lg:hidden">
        {items.map((img, i) => {
          return (
            <HyamPrismicImage
              key={i}
              priority={i < 3}
              field={img.mobile}
              sizesByBreakpoint={{
                sm: 1,
                lg: 1,
                xl: 1,
              }}
            />
          );
        })}
      </div>

      <div className="h-full w-full hidden lg:block">
        {items.map((img, i) => {
          return (
            <HyamPrismicImage
              key={i}
              priority={i < 3}
              field={img.desktop}
              sizesByBreakpoint={{
                sm: 1,
                lg: 1,
                xl: 1,
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export const S01ImageSlidesDesktopMobileDefault = withConfigure<
  S01ImageSlidesDesktopMobileDefaultProps,
  S01ImageSlidesDesktopMobileDefaultStyles
>({
  componentName: "S01ImageSlidesDesktopMobileDefault",
  Component: _S01ImageSlidesDesktopMobileDefault,
  moduleStyles,
});
